import { useEffect, useState } from "react";

export function useIsScrolledToBottom(
  containerId: string,
  offset = 10
): boolean {
  const [isBottom, setIsBottom] = useState(false);

  useEffect(() => {
    const container = document.getElementById(containerId);
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const atBottom = scrollTop + clientHeight >= scrollHeight - offset;
      setIsBottom(atBottom);
    };

    container.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => container.removeEventListener("scroll", handleScroll);
  }, [containerId, offset]);

  return isBottom;
}
